/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from "@irian-ro/abstract-resource";
import { SolutionSegmentViewModel } from "./solution-segment-view.model";

export class ShipmentGroupSolutionViewModel extends JSONable {

  uuid: string | undefined = undefined;

  shipmentGroupUuid: string | undefined = undefined;

  solutionSegmentViewSet: SolutionSegmentViewModel[] = [];

  forOrder: boolean | undefined = undefined;
}
